function sortCollectionByDate(collection, dateField = 'createdDate') {
	return collection.sort(
		(a, b) => new Date(b[dateField]) - new Date(a[dateField])
	);
}

export default sortCollectionByDate;
